// pages/settings/CompanySettings.jsx
import React, { useState, useEffect } from 'react';
//import { useDispatch, useSelector } from 'react-redux';
//import { setToogleHeader } from '../../../core/redux/action';
import { companyActions } from '../../../core/action/companyActions';
import { authActions } from '../../../core/action/authActions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { 
    Save, Upload, Image, Globe, Mail, Phone, 
    MapPin, HelpCircle 
} from 'feather-icons-react/build/IconComponents';
import { useNavigate } from 'react-router-dom';
import ImageWithBasePath from '../../../core/img/imagewithbasebath';

const MySwal = withReactContent(Swal);

const CompanySettings = () => {
    //const dispatch = useDispatch();
    //const data = useSelector((state) => state.toggle_header);
    const navigate = useNavigate();
    
    // State
    const [settings, setSettings] = useState({
        company_name: '',
        company_email: '',
        company_phone: '',
        company_address: '',
        company_website: '',
        gst_number: '',
        pan_number: '',
        company_logo: null,
        company_favicon: null
    });
    
    const [logoPreview, setLogoPreview] = useState(null);
    const [faviconPreview, setFaviconPreview] = useState(null);
    const [logoFile, setLogoFile] = useState(null);
    const [faviconFile, setFaviconFile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    
    // Check permission
    useEffect(() => {
        if (!authActions.hasPermission('edit-settings') && !authActions.isAdmin()) {
            MySwal.fire({
                icon: 'error',
                title: 'Access Denied',
                text: 'You do not have permission to access this page',
                timer: 2000
            }).then(() => {
                navigate('/dashboard');
            });
        }
    }, [navigate]);
    
    // Load settings
    useEffect(() => {
        loadSettings();
    }, []);
    
    const loadSettings = async () => {
        setLoading(true);
        const result = await companyActions.getSettings();
        if (result.success) {
            setSettings(result.data);
            setLogoPreview(result.data.company_logo ? `/${result.data.company_logo}` : null);
            setFaviconPreview(result.data.company_favicon ? `/${result.data.company_favicon}` : null);
        }
        setLoading(false);
    };
    
    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSettings(prev => ({ ...prev, [name]: value }));
    };
    
    // Handle logo change
    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogoFile(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };
    
    // Handle favicon change
    const handleFaviconChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFaviconFile(file);
            setFaviconPreview(URL.createObjectURL(file));
        }
    };
    
    // Handle save
    const handleSave = async () => {
        setSaving(true);
        
        const formData = new FormData();
        
        // Append all settings
        Object.keys(settings).forEach(key => {
            if (settings[key] && !['company_logo', 'company_favicon'].includes(key)) {
                formData.append(key, settings[key]);
            }
        });
        
        // Append files
        if (logoFile) {
            formData.append('company_logo', logoFile);
        }
        if (faviconFile) {
            formData.append('company_favicon', faviconFile);
        }
        
        const result = await companyActions.updateSettings(formData);
        
        if (result.success) {
            MySwal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Company settings updated successfully',
                timer: 2000,
                showConfirmButton: false
            });
            
            // Update previews with new paths
            if (result.data?.company_logo) {
                setLogoPreview(`/${result.data.company_logo}`);
            }
            if (result.data?.company_favicon) {
                setFaviconPreview(`/${result.data.company_favicon}`);
            }
            setLogoFile(null);
            setFaviconFile(null);
        }
        
        setSaving(false);
    };
    
    if (loading) {
        return (
            <div className="page-wrapper">
                <div className="content d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary mb-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <h5 className="text-muted">Loading Settings...</h5>
                    </div>
                </div>
            </div>
        );
    }
    
    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Header */}
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4>Company Settings</h4>
                            <h6>Manage your company information and branding</h6>
                        </div>
                    </div>
                    
                    <ul className="table-top-head">
                        <li>
                            <button 
                                className="btn btn-primary"
                                onClick={handleSave}
                                disabled={saving}
                            >
                                {saving ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Saving...
                                    </>
                                ) : (
                                    <>
                                        <Save size={18} className="me-2" />
                                        Save Changes
                                    </>
                                )}
                            </button>
                        </li>
                        
                    </ul>
                </div>
                
                <div className="row">
                    {/* Left Column - Logo & Favicon */}
                    <div className="col-xl-4">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="mb-0">Branding</h5>
                            </div>
                            <div className="card-body">
                                {/* Company Logo */}
                                <div className="mb-4 text-center">
                                    <label className="form-label d-block">Company Logo</label>
                                    <div className="company-logo mb-3">
                                        {logoPreview ? (
                                            <ImageWithBasePath src={logoPreview} width={'200px'} />
                                            // <img 
                                            //     src={logoPreview} 
                                            //     alt="Company Logo" 
                                            //     style={{ maxWidth: '200px', maxHeight: '100px' }}
                                            // />
                                        ) : (
                                            <div className="bg-light p-4 rounded d-inline-block">
                                                <Image size={48} className="text-muted" />
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <label htmlFor="logo_upload" className="btn btn-outline-primary btn-sm">
                                            <Upload size={14} className="me-1" />
                                            Upload Logo
                                        </label>
                                        <input
                                            type="file"
                                            id="logo_upload"
                                            className="d-none"
                                            accept="image/*"
                                            onChange={handleLogoChange}
                                        />
                                        {logoFile && (
                                            <small className="d-block text-muted mt-2">
                                                New file selected: {logoFile.name}
                                            </small>
                                        )}
                                    </div>
                                </div>
                                
                                {/* Favicon */}
                                <div className="text-center">
                                    <label className="form-label d-block">Favicon</label>
                                    <div className="favicon mb-3">
                                        {faviconPreview ? (
                                            <ImageWithBasePath src={faviconPreview} width={'32px'} height={'32px'} />
                                            // <img 
                                            //     src={faviconPreview} 
                                            //     alt="Favicon" 
                                            //     style={{ width: '32px', height: '32px' }}
                                            // />
                                        ) : (
                                            <div className="bg-light p-2 rounded d-inline-block">
                                                <HelpCircle size={24} className="text-muted" />
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <label htmlFor="favicon_upload" className="btn btn-outline-primary btn-sm">
                                            <Upload size={14} className="me-1" />
                                            Upload Favicon
                                        </label>
                                        <input
                                            type="file"
                                            id="favicon_upload"
                                            className="d-none"
                                            accept="image/*"
                                            onChange={handleFaviconChange}
                                        />
                                        {faviconFile && (
                                            <small className="d-block text-muted mt-2">
                                                New file selected: {faviconFile.name}
                                            </small>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* Right Column - Company Details */}
                    <div className="col-xl-8">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="mb-0">Company Details</h5>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    {/* Company Name */}
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Company Name</label>
                                        <input
                                            type="text"
                                            name="company_name"
                                            className="form-control"
                                            value={settings.company_name || ''}
                                            onChange={handleInputChange}
                                            placeholder="Enter company name"
                                        />
                                    </div>
                                    
                                    {/* Company Email */}
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Company Email</label>
                                        <div className="input-group">
                                            <span className="input-group-text">
                                                <Mail size={16} />
                                            </span>
                                            <input
                                                type="email"
                                                name="company_email"
                                                className="form-control"
                                                value={settings.company_email || ''}
                                                onChange={handleInputChange}
                                                placeholder="info@company.com"
                                            />
                                        </div>
                                    </div>
                                    
                                    {/* Company Phone */}
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Company Phone</label>
                                        <div className="input-group">
                                            <span className="input-group-text">
                                                <Phone size={16} />
                                            </span>
                                            <input
                                                type="tel"
                                                name="company_phone"
                                                className="form-control"
                                                value={settings.company_phone || ''}
                                                onChange={handleInputChange}
                                                placeholder="+91 98765 43210"
                                            />
                                        </div>
                                    </div>
                                    
                                    {/* Company Website */}
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Website</label>
                                        <div className="input-group">
                                            <span className="input-group-text">
                                                <Globe size={16} />
                                            </span>
                                            <input
                                                type="url"
                                                name="company_website"
                                                className="form-control"
                                                value={settings.company_website || ''}
                                                onChange={handleInputChange}
                                                placeholder="https://www.company.com"
                                            />
                                        </div>
                                    </div>
                                    
                                    {/* GST Number */}
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">GST Number</label>
                                        <input
                                            type="text"
                                            name="gst_number"
                                            className="form-control"
                                            value={settings.gst_number || ''}
                                            onChange={handleInputChange}
                                            placeholder="22AAAAA0000A1Z5"
                                        />
                                    </div>
                                    
                                    {/* PAN Number */}
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">PAN Number</label>
                                        <input
                                            type="text"
                                            name="pan_number"
                                            className="form-control"
                                            value={settings.pan_number || ''}
                                            onChange={handleInputChange}
                                            placeholder="AAAAA0000A"
                                        />
                                    </div>
                                    
                                    {/* Address */}
                                    <div className="col-12 mb-3">
                                        <label className="form-label">Address</label>
                                        <div className="input-group">
                                            <span className="input-group-text">
                                                <MapPin size={16} />
                                            </span>
                                            <textarea
                                                name="company_address"
                                                className="form-control"
                                                rows="3"
                                                value={settings.company_address || ''}
                                                onChange={handleInputChange}
                                                placeholder="Enter company address"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompanySettings;